import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { TwemojiWrapper } from '../../components/twemojiWrapper';
import { HeaderTitle } from '../../header/headerTitle';
import { useAppSelector } from '../../redux/store';
import { getHtmlTextContent } from '../../utils/htmlUtils';
export const MttStagingHeaderTitle = () => {
    const gameName = useAppSelector((state) => state.mttStaging.gameName);
    // If the room name had HTML characters in it such as < or >, these will result in '&lt;' and '&gt;' so we need to convert them back:
    const parsedGameName = useMemo(() => getHtmlTextContent(gameName || ''), [gameName]);
    if (!parsedGameName) {
        // add an empty 'filler' HeaderTitle element that will take up remaining space so right side panel controls will be right-justified:
        return _jsx(HeaderTitle, {});
    }
    return _jsx(HeaderTitle, { title: _jsx(TwemojiWrapper, { children: parsedGameName }), subTitle: 'MULTI TABLE TOURNAMENT' });
};
